<div class="ui segment">
  <div class="ui grid">

    <div class="row">
      <div class="thirteen wide column">
        <h3 class="ui header left aligned" i18n="@@articles-filter">Filter:</h3>
      </div>

      <div class="three wide column">
        <h3 class="ui right aligned header" i18n="@@articles-results">{{numberOfArticles}} Ergebnisse</h3>
      </div>
    </div>

    <div class="row">
      <div class="six wide column">
        <div class="field">
          <label for="search">
            <ng-container i18n="@@articles-article-search">Artikelsuche</ng-container>
            <i
              class="info circle icon"
              suiPopup
              popupHeader="Hinweise zur Suche"
              popupPlacement="bottom"
              i18n-popupHeader="@@articles-search-info-title"
              [popupTemplate]="searchInfo"
            ></i>
            <ng-template #searchInfo>
              <ul i18n="@@articles-search-info">
                <li>
                  Bei der Suchfunktion in FIT wird nicht zwischen Groß- und Kleinschreibung unterschieden
                </li>
                <li>
                  Sofern Sie nach Abkürzungen recherchiert haben, prüfen Sie bitte, ob Sie stattdessen das Langwort suchen können
                </li>
              </ul>
            </ng-template>
          </label>
          <div class="ui action input fullWidth">
            <input type="text" id="search" name="search" [(ngModel)]="articlesFilter.q"
                   placeholder="Artikelsuche..." (keydown)="applyFilter($event)" i18n-placeholder="@@articles-article-search-placeholder">
            <button class="ui icon button" (click)="applyFilter()" (keydown)="applyFilter()">
              <i class="search icon search-icon"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="five wide column">
        <div class="field">
          <label for="topicSelect">
            <ng-container i18n="@@article-filter-categories">
              Kategorien
            </ng-container>
            <button class="link topicTypeSwitch" (click)="switchTopicFilterType()">
              @if (articlesFilter.topicFilterType === 'and') {
                <ng-container i18n="@@articles-and-filter">UND</ng-container>
              } @else {
                <ng-container i18n="@@articles-or-filter">ODER</ng-container>
              }
            </button>
            <i class="circle info icon" suiPopup [popupTemplate]="popupTemplate" popupPlacement="bottom"></i>
            <ng-template #popupTemplate i18n="@@articles-or-filter-info">
              UND - Zeige Artikel mit allen ausgewählten Kategorien<br>
              ODER - Zeige Artikel mit mindestens einer der ausgewählten Kategorien
            </ng-template>
          </label>
          <sui-multi-select
            #topicsMultiSelect
            id="topicSelect"
            class="selection fullWidth"
            [options]="topics"
            valueField="_id"
            [labelField]="$localize.locale === 'en' ? 'englishName' : 'name'"
            [(ngModel)]="articlesFilter.topics"
          >
            @for (kind of TOPIC_KINDS; track kind) {
              <div class="header">
                <i class="list icon"></i>
                {{ kind.name }}
              </div>
              <div class="divider"></div>
              @for (option of topicsMultiSelect.filteredOptions; track option._id) {
                @if (option.kind === kind.kind) {
                  <sui-select-option [value]="option"></sui-select-option>
                }
              }
            }
          </sui-multi-select>
        </div>
      </div>

      <div class="five wide column">
        <div class="field">
          <label for="subjectAreaSelect" i18n="@@scientific-fields">Fachrichtungen</label>
          <sui-multi-select
            #subjectAreasMultiSelect
            id="subjectAreaSelect"
            class="selection fullWidth"
            [options]="subjectAreas"
            labelField="name"
            valueField="_id"
            [(ngModel)]="articlesFilter.subjectAreas"
          >
            @for (option of subjectAreasMultiSelect.filteredOptions; track option) {
              <sui-select-option [value]="option"></sui-select-option>
            }
          </sui-multi-select>
        </div>
      </div>

      <div class="four wide column">
        @if (isAdmin) {
          <div class="field">
            <label for="federalStateSelect" i18n="@@articles-federal-states">Bundesländer</label>
            <sui-multi-select
              #federalStateRestrictionsMultiSelect
              id="federalStateSelect"
              class="selection fullWidth"
              labelField="name"
              valueField="state"
              [options]="FEDERAL_STATES"
              [(ngModel)]="articlesFilter.federalStates"
              [isSearchable]="true"
            >
              @for (option of federalStateRestrictionsMultiSelect.filteredOptions; track option) {
                <sui-select-option [value]="option"></sui-select-option>
              }
            </sui-multi-select>
          </div>
        }
      </div>

      <div class="four wide column">
        @if (isAdmin) {
          <div class="field">
            <label for="institutionKindSelect" i18n="@@articles-institution-kind">Art der Institution</label>
            <sui-multi-select
              #institutionKindSelectMultiSelect
              id="institutionKindSelect"
              class="selection fullWidth"
              labelField="name"
              valueField="kind"
              [options]="INSTITUTION_KINDS"
              [(ngModel)]="articlesFilter.institutionKinds"
              [isSearchable]="true"
            >
              @for (option of institutionKindSelectMultiSelect.filteredOptions; track option) {
                <sui-select-option [value]="option"></sui-select-option>
              }
            </sui-multi-select>
          </div>
        }
      </div>
    </div>

    <!-- Third row (16 column wide)-->
    <div class="row">
      <div class="six wide column">
        <!--OTHER FILTERS-->
        <div i18n="@@articles-other-filters">Weitere Filter:</div>
        <div>
          <sui-radio-button name="only" value="" [(ngModel)]="articlesFilter.only" i18n="@@articles-no-restrictions">
            Keine Beschränkungen
          </sui-radio-button>
        </div>
        <div>
          <sui-radio-button name="only" value="onlyArchived" [(ngModel)]="articlesFilter.only" i18n="@@articles-only-archived">
            Nur archivierte Artikel anzeigen
          </sui-radio-button>
        </div>
        <div>
          <sui-radio-button name="only" value="onlyCurrent" [(ngModel)]="articlesFilter.only" i18n="@@articles-only-current">
            Nur aktuelle Artikel anzeigen
          </sui-radio-button>
        </div>
        <div>
          <sui-radio-button name="only" value="permanent" [(ngModel)]="articlesFilter.only" i18n="@@articles-only-permanent">
            Nur Dauer-Ausschreibungen anzeigen (Artikel ohne Frist)
          </sui-radio-button>
        </div>
      </div>

      <div class="ten wide column bottom aligned">
        <button class="ui right floated primary button small" (click)="applyFilter()" i18n="@@articles-apply-filters">
          Filter anwenden
        </button>
        <button class="ui right floated secondary button small" (click)="resetFilter()" i18n="@@articles-reset-filters">
          Filter zurücksetzen
        </button>
        @if (user){
          <button class="ui right floated secondary button small" (click)="applyNewsletterSettings()" i18n="@@articles-newsletter-settings">
            Newsletter-Einstellungen übernehmen
          </button>
        }
      </div>
    </div>
  </div>
</div>
